import React from 'react'
import { useTranslation } from 'react-i18next'
import ScoutText from '../../../../../../common/display/scoutText/ScoutText'
import { DescriptionFieldProps } from '../../../../../../../@types/types'
import { DescriptionScreenValidationResult } from '../../../../../../../@types/validation-types'
import TextArea from '../../../../../../common/inputs/textArea/TextArea'
import { Link } from 'is24-corecss'
import { isWebView } from '../../../../../../../utils/navigation'

export const AdLocation: React.FC<DescriptionFieldProps<DescriptionScreenValidationResult>> = ({
  insertionData,
  validationMessages,
  screenName,
  showLocationSubtitle,
  onChange,
  onHandleLocationChange,
}) => {
  const { t } = useTranslation()
  const isWebViewSet = isWebView()
  const locationLabel = isWebViewSet
    ? t('wizard.screen.description.mobile.adLocation')
    : t('wizard.screen.description.adLocation')
  const labelPlaceholder = t('wizard.screen.description.adLocationPlaceholder')

  return (
    <div className='grid-item margin-top-m'>
      <TextArea
        id='ad-location'
        name='adLocation'
        rows={3}
        placeholder={labelPlaceholder}
        allowResize={true}
        value={insertionData.adLocation}
        errors={validationMessages!.adLocation ?? []}
        label={showLocationSubtitle ? <ScoutText label={locationLabel} /> : locationLabel}
        showMaxLengthLabel={!showLocationSubtitle}
        maxLength={2000}
        onChange={(property, value) => {
          onChange({ screen: screenName, property }, value)
          onHandleLocationChange && onHandleLocationChange()
        }}
      />
      {showLocationSubtitle && (
        <div className='align-right font-body-small-regular margin-bottom-s color-text-weak'>
          <span className='block'>
            {t('wizard.screen.description.openStreetMap', 'Suggested text based on data from OpenStreetMap')}
          </span>
          <span>{t('wizard.screen.description.openStreetMapContributors', 'OpenStreetMap Contributors')}</span>
          <Link variant='weak' href='https://www.openstreetmap.org/copyright'>
            <span className={'font-body-small-regular'}>www.openstreetmap.org/copyright</span>
          </Link>
        </div>
      )}
    </div>
  )
}
